import { createAction } from "@reduxjs/toolkit";
import {
  CREATE_DEAL_ROOM,
  CREATING_DEAL_ROOM_FAILED,
  CREATING_DEAL_ROOM_SUCCEEDED,
  FETCH_DEAL_ROOMS_SUCCEEDED,
  FETCH_DEAL_ROOMS_FAILED, FETCH_DEAL_ROOMS,
  INVALIDATE_DEAL_ROOMS,
  DELETING_DEAL_ROOM_FAILED,
  DELETING_DEAL_ROOM_SUCCEEDED,
  DELETE_DEAL_ROOM,
  UPDATE_DEAL_ROOM,
  UPDATING_DEAL_ROOM_SUCCEEDED,
  UPDATING_DEAL_ROOM_FALIED,
  INVALIDATE_DEAL_ROOMS_DELETION,
  INVALIDATE_DEAL_ROOMS_UPDATION,
  FETCHING_STAKEHOLDERS,
  FETCHING_STAKEHOLDERS_SUCCEEDED,
  FETCHING_STAKEHOLDERS_FAILED,
  DELETING_STAKEHOLDER,
  DELETING_STAKEHOLDER_FAILED,
  DELETING_STAKEHOLDER_SUCCEEDED,
  FETCH_DEAL_ROOM,
  FETCHING_DEAL_ROOM_FAILED,
  FETCHING_DEAL_ROOM_SUCCEEDED,
  INVALIDATE_DEAL_ROOM_CREATION_STATE,
  EDIT_DEAL_ROOM_REQUEST,
  DEAL_ROOM_UPDATE_PROPERTY,
  INVALIDATE_DEAL_ROOM_EDIT_STATE,
  DEAL_ROOM_ADD_ASSETS,
  DEAL_ROOM_REARRANGE_ASSETS,
  DEAL_ROOM_REMOVE_ASSETS,
  DEAL_ROOM_UPDATE_ASSET_METADATA,
  DEAL_ROOM_MOVE_ASSET_TO_SECTION,
  FETCH_DEAL_ROOM_ASSETS,
  FETCHING_DEAL_ROOM_ASSETS_FAILED,
  FETCHING_DEAL_ROOM_ASSETS_SUCCEEDED,
  CREATE_DEAL_ROOM_SECTION_REQUEST,
  UPDATE_DEAL_ROOM_SECTION_REQUEST,
  REMOVE_DEAL_ROOM_SECTION_REQUEST,
  MOVE_DEAL_ROOM_SECTION_REQUEST,
  FETCH_DEAL_ROOM_COLLABORATORS_REQUEST,
  FETCHING_DEAL_ROOM_COLLABORATORS_SUCCEDDED,
  FETCHING_DEAL_ROOM_COLLABORATORS_FAILED,
  UPDATE_DEAL_ROOM_COLLABORATORS_REQUEST,
  UPDATING_DEAL_ROOM_COLLABORATORS_SUCCEDDED,
  UPDATING_DEAL_ROOM_COLLABORATORS_FAILED,
  REARRANGE_DEAL_ROOM_ASSETS,
  FETCH_DEAL_ROOM_ASSETS_FOR_SECTION,
  FETCHING_DEAL_ROOM_ASSETS_FOR_SECTION_SUCCEEDED,
  FETCHING_DEAL_ROOM_ASSETS_FOR_SECTION_FAILED,
  FETCH_DEAL_ROOM_SHARED_ASSETS,
  FETCHING_DEAL_ROOM_SHARED_ASSETS_SUCCEEDED,
  FETCHING_DEAL_ROOM_SHARED_ASSETS_FAILED,
  FETCH_DEAL_ROOM_SHARED_COLLECTIONS,
  FETCHING_DEAL_ROOM_SHARED_COLLECTIONS_SUCCEEDED,
  FETCHING_DEAL_ROOM_SHARED_COLLECTIONS_FAILED,
  FETCH_DEAL_ROOM_DETAILS,
  FETCHING_DEAL_ROOM_DETAILS_SUCCEEDED,
  FETCHING_DEAL_ROOM_DETAILS_FAILED,
  FETCH_DEAL_ROOM_SIGNALS,
  FETCHING_DEAL_ROOM_SIGNALS_SUCCEEDED,
  FETCHING_DEAL_ROOM_SIGNALS_FAILED,
  FETCH_DEAL_ROOM_HISTORY,
  FETCHING_DEAL_ROOM_HISTORY_SUCCEEDED,
  FETCHING_DEAL_ROOM_HISTORY_FAILED,
  INVALIDATE_DEAL_ROOM_COLLABORATORS,
  FETCH_CHAT_USERS_FOR_DEAL_ROOM,
  FETCHING_CHAT_USERS_FOR_DEAL_ROOM_SUCCEEDED,
  FETCHING_CHAT_USERS_FOR_DEAL_ROOM_FAILED,
  FETCH_DEAL_ROOM_CHAT_USERS_REQUEST,
  FETCHING_DEAL_ROOM_CHAT_USERS_SUCCEEDED,
  FETCHING_DEAL_ROOM_CHAT_USERS_FAILED,
  FETCH_DEAL_ROOM_ACTIVE_CHAT_USER_REQUEST,
  FETCHING_DEAL_ROOM_ACTIVE_CHAT_USER_SUCCEEDED,
  FETCHING_DEAL_ROOM_ACTIVE_CHAT_USER_FAILED,
  FETCH_DEAL_ROOM_SMARTCARDS,
  FETCHING_DEAL_ROOM_SMARTCARDS_SUCCEEDED,
  FETCHING_DEAL_ROOM_SMARTCARDS_FAILED,
  FETCH_DEAL_ROOM_ASSET_ANALYTICS_REQUEST,
  FETCHING_DEAL_ROOM_ASSET_ANALYTICS_SUCCEEDED,
  FETCHING_DEAL_ROOM_ASSET_ANALYTICS_FAILED,
  FETCH_DEAL_ROOM_EVENTS,
  FETCHING_DEAL_ROOM_EVENTS_SUCCEEDED,
  FETCHING_DEAL_ROOM_EVENTS_FAILED
} from './actionTypes'

import axios from "axios";
import { takeEvery, call, put, select } from "redux-saga/effects";
import {
  AddAssetToDealRoomRequest,
  ArrangeAssetInDealRoomRequest,
  AssetCatergory,
  CreateDealRoomErrorResponse,
  CreateDealRoomRequest,
  CreateDealRoomResponse,
  CreateDealRoomSectionRequest,
  DealRoom,
  DealRoomEditRequest,
  DeleteDealRoomErrorResponse,
  DeleteDealRoomRequest,
  DeleteDealRoomResponse,
  DeleteStakeholderErrorResponse,
  DeleteStakeholderRequest,
  DeleteStakeholderResponse,
  FetchDealRoomAssetsErrorResponse,
  FetchDealRoomAssetsForSectionErrorResponse,
  FetchDealRoomAssetsForSectionRequest,
  FetchDealRoomAssetsForSectionResponse,
  FetchDealRoomAssetsRequest,
  FetchDealRoomAssetsResponse,
  FetchDealRoomCollaboratorsErrorResponse,
  FetchDealRoomCollaboratorsRequest,
  FetchDealRoomCollaboratorsResponse,
  FetchDealRoomDetailsRequest,
  FetchDealRoomErrorResponse,
  FetchDealRoomHistoryRequest,
  FetchDealRoomRequest,
  FetchDealRoomResponse,
  FetchDealRoomsErrorResponse,
  FetchDealRoomSharedAssetsErrorResponse,
  FetchDealRoomSharedAssetsRequest,
  FetchDealRoomSharedAssetsResponse,
  FetchDealRoomSharedCollectionsErrorResponse,
  FetchDealRoomSharedCollectionsRequest,
  FetchDealRoomSharedCollectionsResponse,
  FetchDealRoomSignalsRequest,
  FetchDealRoomsRequest,
  FetchDealRoomsResponse,
  FetchingDealRoomDetailsErrorResponse,
  FetchingDealRoomDetailsResponse,
  FetchingDealRoomHistoryErrorResponse,
  FetchingDealRoomHistoryResponse,
  FetchingDealRoomSignalsErrorResponse,
  FetchingDealRoomSignalsResponse,
  FetchStakeholdersErrorResponse,
  FetchStakeholdersRequest,
  FetchStakeholdersResponse,
  MoveAssetToSectionRequest,
  MoveDealRoomSectionRequest,
  RearrangeAssetInDealRoomRequest,
  RemoveAssetFromDealRoomRequest,
  RemoveDealRoomSectionRequest,
  RenameDealRoomSectionRequest,
  UpdateAssetMetadataRequest,
  UpdateDealRoomCollaboratorsErrorResponse,
  UpdateDealRoomCollaboratorsRequest,
  UpdateDealRoomCollaboratorsResponse,
  UpdateDealRoomErrorResponse,
  UpdateDealRoomPropertyRequest,
  UpdateDealRoomRequest,
  UpdateDealRoomResponse,
  FetchDealRoomEngageChatUsersRequest,
  FetchingDealRoomEngageChatUsersResponse,
  FetchingDealRoomEngageChatUsersErrorResponse,
  FetchDealRoomActiveChatUserRequest,
  FetchingDealRoomActiveChatUserResponse,
  FetchingDealRoomActiveChatUserErrorResponse,
  FetchDealRoomSmartCardsRequest,
  FetchDealRoomSmartCardsResponse,
  FetchDealRoomSmartCardsErrorResponse,
  FetchDealRoomAssetAnalyticsRequest,
  FetchDealRoomAssetAnalyticsResponse,
  FetchDealRoomAssetAnalyticsErrorResponse,
  FetchDealRoomEventsRequest,
  FetchDealRoomEventsResponse,
  FetchDealRoomEventsErrorResponse,
} from "../../types/dealRoom";

import buildUrl from "build-url-ts";
import _ from "lodash";

// eslint-disable-next-line no-undef
const apiUrl = `${process.env.REACT_APP_API_URL}`;
const DEAL_ROOMS_BASE_URL = `${apiUrl}/api/1.0/dealRoom`;
const COLLECTION_BASE_URL = `${apiUrl}/api/2.0/collections`;
const COLLECTIONS_BASE_URL = `${apiUrl}/api/2.0/collections`;

const DEAL_ROOM_BASE_URL = `${apiUrl}/api/2.1/deal_room`;
const DEAL_ROOM_ENGAGE_BASE_URL = `${apiUrl}/api/2.1/deal_room`;
const DEAL_ROOM_CHAT_USER_BASE_URL = `${apiUrl}/api/2.0/chat_users`;

// create dealroom
export const createDealRoom = createAction<CreateDealRoomRequest>(CREATE_DEAL_ROOM);
const creatingDealRoomSucceeded = createAction<CreateDealRoomResponse>(CREATING_DEAL_ROOM_SUCCEEDED);
const creatingDealRoomFailed = createAction<CreateDealRoomErrorResponse>(CREATING_DEAL_ROOM_FAILED);
export const invalidateDealRoomCreationState = createAction<void>(INVALIDATE_DEAL_ROOM_CREATION_STATE);

const createDealRoomSaga = function* (action: ReturnType<typeof createDealRoom>): any {
  const request = action.payload;

  const createDealRoomApi = () => {
    return axios({
      method: 'POST',
      url: DEAL_ROOM_BASE_URL,
      data: request
    }).then((response) => response.data);
  };

  try {
    const response = yield call(createDealRoomApi);
    yield put(creatingDealRoomSucceeded({ response }));
  } catch (error) {
    yield put(creatingDealRoomFailed({ error: error }));
  }
};

export const fetchDealRooms = createAction<FetchDealRoomsRequest>(FETCH_DEAL_ROOMS);
const fetchingDealRoomsSucceeded = createAction<FetchDealRoomsResponse>(FETCH_DEAL_ROOMS_SUCCEEDED);
const fetchingDealRoomsFailed = createAction<FetchDealRoomsErrorResponse>(FETCH_DEAL_ROOMS_FAILED);

const fetchDealRoomsSaga = function* (action: ReturnType<typeof fetchDealRooms>): any {
  const request = action.payload;

  const fetchDealRoomsApi = () => {
    return axios({
      method: 'GET',
      url: DEAL_ROOM_BASE_URL,
      params: request
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchDealRoomsApi);
    yield put(fetchingDealRoomsSucceeded({
      filter: request.filter,
      response: response
    }));
  } catch (error) {
    yield put(fetchingDealRoomsFailed({ filter: request.filter, error: error }));
  }
};

export const fetchDealRoom = createAction<FetchDealRoomRequest>(FETCH_DEAL_ROOM);
const fetchingDealRoomSucceeded = createAction<FetchDealRoomResponse>(FETCHING_DEAL_ROOM_SUCCEEDED);
const fetchingDealRoomFailed = createAction<FetchDealRoomErrorResponse>(FETCHING_DEAL_ROOM_FAILED);

const fetchDealRoomSaga = function* (action: ReturnType<typeof fetchDealRoom>): any {
  const { id } = action.payload;

  const fetchDealRoomApi = () => {
    return axios({
      method: 'GET',
      url: `${DEAL_ROOM_BASE_URL}/${id}`
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchDealRoomApi);
    yield put(fetchingDealRoomSucceeded({ response }));
  } catch (error) {
    yield put(fetchingDealRoomFailed({ id, error: error }));
  }
};

//Delete DealRoom
export const deleteDealRoom = createAction<DeleteDealRoomRequest>(DELETE_DEAL_ROOM);
const deletingDealRoomSucceeded = createAction<DeleteDealRoomResponse>(DELETING_DEAL_ROOM_SUCCEEDED);
const deletingDealRoomFailed = createAction<DeleteDealRoomErrorResponse>(DELETING_DEAL_ROOM_FAILED);

const deleteDealRoomSaga = function* (action: ReturnType<typeof deleteDealRoom>): any {
  const { id } = action.payload;

  const deleteDealRoomApi = () => {
    return axios({
      method: 'DELETE',
      url: `${DEAL_ROOM_BASE_URL}/${id}`,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(deleteDealRoomApi);
    yield put(deletingDealRoomSucceeded({ id: id, response: response }));
  } catch (error) {
    yield put(deletingDealRoomFailed({ id: id, error: error }));
  }
};

export const updateDealRoom = createAction<UpdateDealRoomRequest>(UPDATE_DEAL_ROOM);
const updatingDealRoomSucceeded = createAction<UpdateDealRoomResponse>(UPDATING_DEAL_ROOM_SUCCEEDED);
const updatingDealRoomFailed = createAction<UpdateDealRoomErrorResponse>(UPDATING_DEAL_ROOM_FALIED);

const updateDealRoomSaga = function* (action: ReturnType<typeof updateDealRoom>): any {
  const { id, request } = action.payload;

  const updateDealRoomApi = () => {
    return axios({
      method: 'POST',
      url: `${DEAL_ROOM_BASE_URL}/${id}`,
      data: request
    }).then((response) => response.data);
  };

  try {
    const response = yield call(updateDealRoomApi);
    yield put(updatingDealRoomSucceeded({ response: response }));
  } catch (error) {
    yield put(updatingDealRoomFailed({ id: id, error: error }));
  }
};

export const invalidateDealRooms = createAction<void>(INVALIDATE_DEAL_ROOMS);
export const invalidateDealRoomUpdationState = createAction<void>(INVALIDATE_DEAL_ROOMS_UPDATION);
export const invalidateDealRoomDeletionState = createAction<void>(INVALIDATE_DEAL_ROOMS_DELETION);

export const editDealRoom = createAction<DealRoomEditRequest>(EDIT_DEAL_ROOM_REQUEST);
export const updateDealRoomProperties = createAction<UpdateDealRoomPropertyRequest>(DEAL_ROOM_UPDATE_PROPERTY);
export const invalidateEditDealRoom = createAction<string>(INVALIDATE_DEAL_ROOM_EDIT_STATE);
export const rearrageDealRoomAssets = createAction<RearrangeAssetInDealRoomRequest>(REARRANGE_DEAL_ROOM_ASSETS);
export const fetchStakeholders = createAction<FetchStakeholdersRequest>(FETCHING_STAKEHOLDERS);
export const fetchingStakeholdersSucceeded = createAction<FetchStakeholdersResponse>(FETCHING_STAKEHOLDERS_SUCCEEDED);
export const fetchingStakeholdersFailed = createAction<FetchStakeholdersErrorResponse>(FETCHING_STAKEHOLDERS_FAILED);
export const invalidateDealRoomCollaborators = createAction<string>(INVALIDATE_DEAL_ROOM_COLLABORATORS);

const fetchStakeholdersSaga = function* (action: ReturnType<typeof fetchStakeholders>): any {
  const { dealRoomId, page, type } = action.payload;
  let url = buildUrl(DEAL_ROOM_BASE_URL, {
    path: `/${dealRoomId}/people`,
    queryParams: {
      page: page,
      type: type,
      limit: 20
    }
  });

  const fetchStakeholdersApi = () => {
    return axios({
      method: 'GET',
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchStakeholdersApi);
    yield put(fetchingStakeholdersSucceeded({
      dealRoomId: dealRoomId,
      type: type,
      response: response
    }));
  } catch (error) {
    yield put(fetchingStakeholdersFailed({
      error: error,
      dealRoomId: dealRoomId,
      type: type
    }));
  }
};

export const deleteStakeholder = createAction<DeleteStakeholderRequest>(DELETING_STAKEHOLDER);
export const deletingStakeholderSucceeded = createAction<DeleteStakeholderResponse>(DELETING_STAKEHOLDER_SUCCEEDED);
export const deletingStakeholderFailed = createAction<DeleteStakeholderErrorResponse>(DELETING_STAKEHOLDER_FAILED);

const deleteStakeholderSaga = function* (action: ReturnType<typeof deleteStakeholder>): any {
  const { dealRoomId, stakeholderType, recipientId } = action.payload;

  let url = buildUrl(DEAL_ROOM_BASE_URL, {
    path: `${dealRoomId}/people/${recipientId}`,
    queryParams: {
      type: stakeholderType,
    }
  });

  const deleteStakeholderApi = () => {
    return axios({
      method: 'DELETE',
      url: url
    }).then((response) => response.data);
  };

  try {
    const response = yield call(deleteStakeholderApi);
    yield put(deletingStakeholderSucceeded({
      dealRoomId: dealRoomId
    }));
  } catch (error) {
    yield put(deletingStakeholderFailed({
      dealRoomId: dealRoomId,
      error: error
    }));
  }

};

export const addAssetToDealRoom = createAction<AddAssetToDealRoomRequest>(DEAL_ROOM_ADD_ASSETS);
export const moveAsset = createAction<ArrangeAssetInDealRoomRequest>(DEAL_ROOM_REARRANGE_ASSETS);
export const moveAssetToSection = createAction<MoveAssetToSectionRequest>(DEAL_ROOM_MOVE_ASSET_TO_SECTION);
export const removeAssetFromDealRoom = createAction<RemoveAssetFromDealRoomRequest>(DEAL_ROOM_REMOVE_ASSETS);
export const updateAssetMetadata = createAction<UpdateAssetMetadataRequest>(DEAL_ROOM_UPDATE_ASSET_METADATA);

const moveAssetToSectionSaga = function* (action: ReturnType<typeof moveAssetToSection>): any {
  const { dealRoom, source, target, asset } = action.payload;

  yield put(removeAssetFromDealRoom({
    dealRoom: dealRoom,
    section: source,
    asset: asset.id
  })
  )

  const targetSection = yield select((state) => state.dealRooms.edit.dealRoom.sections[target]);

  if (!targetSection.loaded) {
    yield call(fetchDealRoomAssetsForSectionSaga, fetchDealRoomAssetsForSection({
      id: dealRoom,
      page: 0,
      limit: 20,
      sectionId: targetSection.item.id,
      assetCategory: AssetCatergory.INTERNAL
    }));
  }

  yield put(addAssetToDealRoom({
    dealRoom: dealRoom,
    section: target,
    assets: [asset],
    addAt: 'start'
  }));

}


export const fetchDealRoomAssets = createAction<FetchDealRoomAssetsRequest>(FETCH_DEAL_ROOM_ASSETS);
export const fetchingDealRoomAssetsSucceeded = createAction<FetchDealRoomAssetsResponse>(FETCHING_DEAL_ROOM_ASSETS_SUCCEEDED);
export const fetchingDealRoomAssetsFailed = createAction<FetchDealRoomAssetsErrorResponse>(FETCHING_DEAL_ROOM_ASSETS_FAILED);

const fetchDealRoomAssetsSaga = function* (action: ReturnType<typeof fetchDealRoomAssets>): any {
  const {id, page, limit, assetCategory } = action.payload;

  const url = buildUrl(DEAL_ROOM_BASE_URL, {
    path: `${id}/assets`,
    queryParams: {
      page: page,
      limit: limit,
      assetCategory: assetCategory
    }
  });

  const fetchDealRoomAssetsApi = () => {
    return axios({
      method: 'GET',
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchDealRoomAssetsApi);

    yield put(fetchingDealRoomAssetsSucceeded({
      id: id,
      response: response,
      assetCategory: assetCategory
    }));

    for (const asset of response.records) {
      yield put(fetchDealRoomAssetAnalytics({
        dealRoomId: id,
        assetId: asset.asset.id,
        assetCategory
      }));
    }
  } catch (error) {
    yield put(fetchingDealRoomAssetsFailed({
      id: id,
      assetCategory: assetCategory,
      error: error
    }));
  }
};

export const fetchDealRoomAssetsForSection = createAction<FetchDealRoomAssetsForSectionRequest>(FETCH_DEAL_ROOM_ASSETS_FOR_SECTION);
export const fetchingDealRoomAssetsForSectionSucceeded = createAction<FetchDealRoomAssetsForSectionResponse>(FETCHING_DEAL_ROOM_ASSETS_FOR_SECTION_SUCCEEDED);
export const fetchingDealRoomAssetsForSectionFailed = createAction<FetchDealRoomAssetsForSectionErrorResponse>(FETCHING_DEAL_ROOM_ASSETS_FOR_SECTION_FAILED);

const fetchDealRoomAssetsForSectionSaga = function* (action: ReturnType<typeof fetchDealRoomAssetsForSection>): any {
  const {id, sectionId, page, limit, assetCategory } = action.payload;

  const url = buildUrl(DEAL_ROOM_BASE_URL, {
    path: `${id}/section/${sectionId}/assets`,
    queryParams: {
      page: page,
      limit: limit,
      assetCategory: assetCategory
    }
  });

  const fetchDealRoomAssetsApi = () => {
    return axios({
      method: 'GET',
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchDealRoomAssetsApi);
    yield put(fetchingDealRoomAssetsForSectionSucceeded({
      id: id,
      response: response,
      assetCategory: assetCategory,
      sectionId: sectionId
    }));

    for (const asset of response.records) {
      yield put(fetchDealRoomAssetAnalytics({
        dealRoomId: id,
        assetId: asset.asset.id,
        assetCategory,
        sectionId
      }));
    }
  } catch (error) {
    yield put(fetchingDealRoomAssetsForSectionFailed({
      id: id,
      assetCategory: assetCategory,
      error: error,
      sectionId: sectionId
    }));
  }
};

export const createSection = createAction<CreateDealRoomSectionRequest>(CREATE_DEAL_ROOM_SECTION_REQUEST);
export const renameSection = createAction<RenameDealRoomSectionRequest>(UPDATE_DEAL_ROOM_SECTION_REQUEST);
export const removeSection = createAction<RemoveDealRoomSectionRequest>(REMOVE_DEAL_ROOM_SECTION_REQUEST);
export const moveSection = createAction<MoveDealRoomSectionRequest>(MOVE_DEAL_ROOM_SECTION_REQUEST);

const createDealRoomSectionSaga = function* (action: ReturnType<typeof createSection>): any {
  const { dealRoom } = action.payload;

  const existingSections = yield select((state) => _.get(state, 'dealRooms.edit.dealRoom.sections') || []);

  if (existingSections.length > 1) {
    return;
  }

  const existingAssets = yield select((state) => {
    return _.get(state, 'dealRooms.edit.assets.items') || [];
  });

  if (_.size(existingAssets) > 0) {
    yield put(createSection({
      dealRoom: dealRoom,
      name: 'Others'
    }));

    yield put(addAssetToDealRoom({
      dealRoom: dealRoom,
      section: 1,
      assets: existingAssets,
      addAt: 'end'
    }));
  }
}

export const fetchCollaboratorsForDealRoom = createAction<FetchDealRoomCollaboratorsRequest>(FETCH_DEAL_ROOM_COLLABORATORS_REQUEST);
const fetchingCollaboratorsForDealRoomSucceeded = createAction<FetchDealRoomCollaboratorsResponse>(FETCHING_DEAL_ROOM_COLLABORATORS_SUCCEDDED);
const fetchingCollaboratorsForDealRoomFailed = createAction<FetchDealRoomCollaboratorsErrorResponse>(FETCHING_DEAL_ROOM_COLLABORATORS_FAILED);

const fetchCollaboratorsForDealRoomSaga = function* (action: ReturnType<typeof fetchCollaboratorsForDealRoom>): any {
  const { dealRoom, query, page } = action.payload as FetchDealRoomCollaboratorsRequest;

  const url = buildUrl(DEAL_ROOM_BASE_URL, {
    path: `${dealRoom}/users`,
    queryParams: {
      query: query,
      page: page,
    }
  });

  const fetchCollaboratorsApi = () => {
    return axios({
      method: 'GET',
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchCollaboratorsApi);
    yield put(fetchingCollaboratorsForDealRoomSucceeded({
      dealRoom: dealRoom,
      response: response
    }));
  } catch (error) {
    yield put(fetchingCollaboratorsForDealRoomFailed({ dealRoom: dealRoom, error: error }));
  }
};

export const updateCollaboratorsForDealRoom = createAction<UpdateDealRoomCollaboratorsRequest>(UPDATE_DEAL_ROOM_COLLABORATORS_REQUEST);
const updatingCollaboratorsForDealRoomSucceeded = createAction<UpdateDealRoomCollaboratorsResponse>(UPDATING_DEAL_ROOM_COLLABORATORS_SUCCEDDED);
const updatingCollaboratorsForDealRoomFailed = createAction<UpdateDealRoomCollaboratorsErrorResponse>(UPDATING_DEAL_ROOM_COLLABORATORS_FAILED);

const updateCollaboratorsForDealRoomSaga = function* (action: ReturnType<typeof updateCollaboratorsForDealRoom>): any {
  const { dealRoom, requestBody } = action.payload as UpdateDealRoomCollaboratorsRequest;

  const url = buildUrl(DEAL_ROOM_BASE_URL, {
    path: `${dealRoom}/collaborators`,
  });

  const updateCollaboratorsApi = () => {
    return axios({
      method: 'PUT',
      url: url,
      data: requestBody
    }).then((response) => response.data);
  };

  try {
    const response = yield call(updateCollaboratorsApi);
    yield put(updatingCollaboratorsForDealRoomSucceeded({
      dealRoom: dealRoom,
      response: response
    }));
  } catch (error) {
    yield put(updatingCollaboratorsForDealRoomFailed({ dealRoom: dealRoom, error: error }));
  }
};

export const fetchDealRoomSharedAssets = createAction<FetchDealRoomSharedAssetsRequest>(FETCH_DEAL_ROOM_SHARED_ASSETS);
const fetchingDealRoomSharedAssetsSucceeded = createAction<FetchDealRoomSharedAssetsResponse>(FETCHING_DEAL_ROOM_SHARED_ASSETS_SUCCEEDED);
const fetchingDealRoomSharedAssetsFailed = createAction<FetchDealRoomSharedAssetsErrorResponse>(FETCHING_DEAL_ROOM_SHARED_ASSETS_FAILED);

const fetchDealRoomSharedAssetsSaga = function* (action: ReturnType<typeof fetchDealRoomSharedAssets>): any {
  const { dealRoomId, dealId, page } = action.payload as FetchDealRoomSharedAssetsRequest;

  const url = buildUrl(DEAL_ROOM_BASE_URL, {
    path: `${dealRoomId}/shared/assets/${dealId}`,
    queryParams: {
      page,
      limit: 20,
    }
  });

  const fetchDealRoomSharedAssetsApi = () => {
    return axios({
      method: 'GET',
      url,
    }).then((response) => {
      return response.data;
    });
  }

  try {
    const response = yield call(fetchDealRoomSharedAssetsApi);
    yield put(fetchingDealRoomSharedAssetsSucceeded({
      response,
      dealRoomId
    }));
  } catch (error) {
    yield put(fetchingDealRoomSharedAssetsFailed({
      error,
      dealRoomId
    }));
  }
}

export const fetchDealRoomSharedCollections = createAction<FetchDealRoomSharedCollectionsRequest>(FETCH_DEAL_ROOM_SHARED_COLLECTIONS);
const fetchingDealRoomSharedCollectionsSucceeded = createAction<FetchDealRoomSharedCollectionsResponse>(FETCHING_DEAL_ROOM_SHARED_COLLECTIONS_SUCCEEDED);
const fetchingDealRoomSharedCollectionsFailed = createAction<FetchDealRoomSharedCollectionsErrorResponse>(FETCHING_DEAL_ROOM_SHARED_COLLECTIONS_FAILED);

const fetchDealRoomSharedCollectionsSaga = function* (action: ReturnType<typeof fetchDealRoomSharedAssets>): any {
  const { dealRoomId, dealId } = action.payload as FetchDealRoomSharedCollectionsRequest;

  const url = buildUrl(DEAL_ROOM_BASE_URL, {
    path: `${dealRoomId}/shared/collections/${dealId}`,
  });

  const fetchDealRoomSharedCollectionsApi = () => {
    return axios({
      method: 'GET',
      url,
    }).then((response) => {
      return response.data;
    });
  }

  try {
    const response = yield call(fetchDealRoomSharedCollectionsApi);
    yield put(fetchingDealRoomSharedCollectionsSucceeded({
      response,
      dealRoomId
    }));
  } catch (error) {
    yield put(fetchingDealRoomSharedCollectionsFailed({
      error,
      dealRoomId
    }));
  }
}

export const fetchDealRoomDetails = createAction<FetchDealRoomDetailsRequest>(FETCH_DEAL_ROOM_DETAILS);
const fetchingDealRoomDetailsSucceeded = createAction<FetchingDealRoomDetailsResponse>(FETCHING_DEAL_ROOM_DETAILS_SUCCEEDED);
const fetchingDealRoomDetailsFailed = createAction<FetchingDealRoomDetailsErrorResponse>(FETCHING_DEAL_ROOM_DETAILS_FAILED);

const fetchDealRoomDetailsSaga = function* (action: ReturnType<typeof fetchDealRoomSharedAssets>): any {
  const { dealRoomId, dealId } = action.payload as FetchDealRoomSharedAssetsRequest;

  const url = buildUrl(DEAL_ROOM_BASE_URL, {
    path: `${dealRoomId}/deal_details/${dealId}`,
  });

  const fetchDealRoomDetailsApi = () => {
    return axios({
      method: 'GET',
      url,
    }).then((response) => {
      return response.data;
    });
  }

  try {
    const response = yield call(fetchDealRoomDetailsApi);
    yield put(fetchingDealRoomDetailsSucceeded({
      response,
      dealRoomId
    }));
  } catch (error) {
    yield put(fetchingDealRoomDetailsFailed({
      error,
      dealRoomId
    }));
  }
}

export const fetchDealRoomSignals = createAction<FetchDealRoomSignalsRequest>(FETCH_DEAL_ROOM_SIGNALS);
const fetchingDealRoomSignalsSucceeded = createAction<FetchingDealRoomSignalsResponse>(FETCHING_DEAL_ROOM_SIGNALS_SUCCEEDED);
const fetchingDealRoomSignalsFailed = createAction<FetchingDealRoomSignalsErrorResponse>(FETCHING_DEAL_ROOM_SIGNALS_FAILED);

const fetchDealRoomSignalsSaga = function* (action: ReturnType<typeof fetchDealRoomSharedAssets>): any {
  const { dealRoomId, dealId, page } = action.payload as FetchDealRoomSharedAssetsRequest;

  const url = buildUrl(DEAL_ROOM_BASE_URL, {
    path: `${dealRoomId}/deal/signals/${dealId}`,
    queryParams: {
      page,
      limit: 5,
    }
  });

  const fetchDealRoomSignalsApi = () => {
    return axios({
      method: 'GET',
      url,
    }).then((response) => {
      return response.data;
    });
  }

  try {
    const response = yield call(fetchDealRoomSignalsApi);
    yield put(fetchingDealRoomSignalsSucceeded({
      response,
      dealRoomId
    }));
  } catch (error) {
    yield put(fetchingDealRoomSignalsFailed({
      error,
      dealRoomId
    }));
  }
}

export const fetchDealRoomHistory = createAction<FetchDealRoomHistoryRequest>(FETCH_DEAL_ROOM_HISTORY);
const fetchingDealRoomHistorySucceeded = createAction<FetchingDealRoomHistoryResponse>(FETCHING_DEAL_ROOM_HISTORY_SUCCEEDED);
const fetchingDealRoomHistoryFailed = createAction<FetchingDealRoomHistoryErrorResponse>(FETCHING_DEAL_ROOM_HISTORY_FAILED);

const fetchDealRoomHistorySaga = function* (action: ReturnType<typeof fetchDealRoomSharedAssets>): any {
  const { dealRoomId, dealId, page } = action.payload as FetchDealRoomSharedAssetsRequest;

  const url = buildUrl(DEAL_ROOM_BASE_URL, {
    path: `${dealRoomId}/deal/prediction/${dealId}`,
    queryParams: {
      page,
      limit: 300,
    }
  });

  const fetchDealRoomHistoryApi = () => {
    return axios({
      method: 'GET',
      url,
    }).then((response) => {
      return response.data;
    });
  }

  try {
    const response = yield call(fetchDealRoomHistoryApi);
    yield put(fetchingDealRoomHistorySucceeded({
      response,
      dealRoomId
    }));
  } catch (error) {
    yield put(fetchingDealRoomHistoryFailed({
      error,
      dealRoomId
    }));
  }
}

export const fetchDealRoomEngageChatUsers = createAction<FetchDealRoomEngageChatUsersRequest>(FETCH_DEAL_ROOM_CHAT_USERS_REQUEST);
const fetchingDealRoomEngageChatUsersSucceeded = createAction<FetchingDealRoomEngageChatUsersResponse>(FETCHING_DEAL_ROOM_CHAT_USERS_SUCCEEDED);
const fetchingDealRoomEngageChatUsersFailed = createAction<FetchingDealRoomEngageChatUsersErrorResponse>(FETCHING_DEAL_ROOM_CHAT_USERS_FAILED);

const fetchChatUsersForDealRoomSaga = function* (action: ReturnType<typeof fetchDealRoomEngageChatUsers>): any {
  const { dealRoomId, page } = action.payload as FetchDealRoomEngageChatUsersRequest;

  const url = buildUrl(DEAL_ROOM_ENGAGE_BASE_URL, {
    path: `${dealRoomId}/chat-user`,
    queryParams: {
      page: page
    }
  });

  const fetchChatUsersApi = async () => {
    const response = await axios({
      method: 'GET',
      url: url,
    });
    return response.data;
  };

  try {
    const response = yield call(fetchChatUsersApi);
    yield put(fetchingDealRoomEngageChatUsersSucceeded({ response, dealRoomId }));
  } catch (error) {
    yield put(fetchingDealRoomEngageChatUsersFailed({ error, dealRoomId }))
  }
}

export const fetchDealRoomActiveChatUser = createAction<FetchDealRoomActiveChatUserRequest>(FETCH_DEAL_ROOM_ACTIVE_CHAT_USER_REQUEST);
const fetchingDealRoomEngageChatUserSucceeded = createAction<FetchingDealRoomActiveChatUserResponse>(FETCHING_DEAL_ROOM_ACTIVE_CHAT_USER_SUCCEEDED);
const fetchingDealRoomEngageChatUserFailed = createAction<FetchingDealRoomActiveChatUserErrorResponse>(FETCHING_DEAL_ROOM_ACTIVE_CHAT_USER_FAILED);

const fetchActiveChatUserForDealRoomSaga = function* (action: ReturnType<typeof fetchDealRoomActiveChatUser>): any {
  const { dealRoomId, chatUserId } = action.payload as FetchDealRoomActiveChatUserRequest;
  const url = buildUrl(DEAL_ROOM_CHAT_USER_BASE_URL, {
    path: `${chatUserId}`
  });

  const fetchActiveChatUserApi = async () => {
    const response = await axios({
      method: 'GET',
      url: url,
    });
    return response.data;
  };

  try {
    const response = yield call(fetchActiveChatUserApi);
    yield put(fetchingDealRoomEngageChatUserSucceeded({ response, dealRoomId }));
  } catch (error) {
    yield put(fetchingDealRoomEngageChatUserFailed({ error, dealRoomId }))
  }
}

export const fetchDealRoomSmartCards = createAction<FetchDealRoomSmartCardsRequest>(FETCH_DEAL_ROOM_SMARTCARDS);
const fetchingDealRoomSmartCardsSucceeded = createAction<FetchDealRoomSmartCardsResponse>(FETCHING_DEAL_ROOM_SMARTCARDS_SUCCEEDED);
const fetchingDealRoomSmartCardsFailed = createAction<FetchDealRoomSmartCardsErrorResponse>(FETCHING_DEAL_ROOM_SMARTCARDS_FAILED);

const fetchDealRoomSmartCardsSaga = function* (action: ReturnType<typeof fetchDealRoomEngageChatUsers>): any {
  const { dealRoomId } = action.payload as FetchDealRoomEngageChatUsersRequest;

  const url = buildUrl(DEAL_ROOM_BASE_URL, {
    path: `${dealRoomId}/smart-card`
  });

  const fetchSmartCardsApi = async () => {
    const response = await axios({
      method: 'GET',
      url: url,
    });
    return response.data;
  };

  try {
    const response = yield call(fetchSmartCardsApi);
    yield put(fetchingDealRoomSmartCardsSucceeded({ response, dealRoomId }));
  } catch (error) {
    yield put(fetchingDealRoomSmartCardsFailed({ error, dealRoomId }))
  }
}

const fetchDealRoomAssetAnalytics = createAction<FetchDealRoomAssetAnalyticsRequest>(FETCH_DEAL_ROOM_ASSET_ANALYTICS_REQUEST);
const fetchingDealRoomAssetAnalyticsSucceeded = createAction<FetchDealRoomAssetAnalyticsResponse>(FETCHING_DEAL_ROOM_ASSET_ANALYTICS_SUCCEEDED)
const fetchingDealRoomAssetAnalyticsFailed = createAction<FetchDealRoomAssetAnalyticsErrorResponse>(FETCHING_DEAL_ROOM_ASSET_ANALYTICS_FAILED);


const fetchDealRoomAssetAnalyticsSaga = function* (action: ReturnType<typeof fetchDealRoomAssetAnalytics>): any {
  const {dealRoomId, assetId, assetCategory, sectionId } = action.payload;

  const url = buildUrl(DEAL_ROOM_BASE_URL, {
    path: `${dealRoomId}/analytics/asset/${assetId}`
  });

  const fetchSmartCardsApi = async () => {
    const response = await axios({
      method: 'GET',
      url: url,
    });
    return response.data;
  };

  try {
    const response = yield call(fetchSmartCardsApi);
    yield put(fetchingDealRoomAssetAnalyticsSucceeded({ response, dealRoomId, assetId, assetCategory, sectionId }));
  } catch (error) {
    yield put(fetchingDealRoomAssetAnalyticsFailed({ error, dealRoomId, assetId, assetCategory, sectionId }))
  }
}

export const fetchDealRoomEvents = createAction<FetchDealRoomEventsRequest>(FETCH_DEAL_ROOM_EVENTS);
const fetchingDealRoomEventsSucceeded = createAction<FetchDealRoomEventsResponse>(FETCHING_DEAL_ROOM_EVENTS_SUCCEEDED);
const fetchingDealRoomEventsFailed = createAction<FetchDealRoomEventsErrorResponse>(FETCHING_DEAL_ROOM_EVENTS_FAILED);

const fetchDealRoomEventsSaga = function* (action: ReturnType<typeof fetchDealRoomEvents>): any {
  let { request, page, dealRoomId } = action.payload;

  const params = {
    page: page,
    limit: 20
  };

  const url = buildUrl(DEAL_ROOM_BASE_URL, {
    path: `${dealRoomId}/events`
  });
  if(request.eventTypes.includes('all')) {
    request = {
      ...request,
      eventTypes:[]
    }
  }
  const fetchDealRoomEventsApi = () => {
    return axios({
      method: 'POST',
      url: url,
      data: request,
      params
    }).then((response) => response.data);
  }

  try {
    const response = yield call(fetchDealRoomEventsApi);
    yield put(fetchingDealRoomEventsSucceeded({request, data: response, dealRoomId }));
  } catch (error) {
    yield put(fetchingDealRoomEventsFailed({request, error: error, dealRoomId }));
  }
}


export default function* dealRoomsSaga() {
  yield takeEvery(CREATE_DEAL_ROOM, createDealRoomSaga);
  yield takeEvery(FETCH_DEAL_ROOMS, fetchDealRoomsSaga);
  yield takeEvery(DELETE_DEAL_ROOM, deleteDealRoomSaga);
  yield takeEvery(UPDATE_DEAL_ROOM, updateDealRoomSaga);
  yield takeEvery(FETCHING_STAKEHOLDERS, fetchStakeholdersSaga);
  yield takeEvery(DELETING_STAKEHOLDER, deleteStakeholderSaga);
  yield takeEvery(FETCH_DEAL_ROOM, fetchDealRoomSaga);
  yield takeEvery(FETCH_DEAL_ROOM_ASSETS, fetchDealRoomAssetsSaga);
  yield takeEvery(FETCH_DEAL_ROOM_ASSETS_FOR_SECTION, fetchDealRoomAssetsForSectionSaga);
  yield takeEvery(FETCH_DEAL_ROOM_COLLABORATORS_REQUEST, fetchCollaboratorsForDealRoomSaga);
  yield takeEvery(UPDATE_DEAL_ROOM_COLLABORATORS_REQUEST, updateCollaboratorsForDealRoomSaga);
  yield takeEvery(DEAL_ROOM_MOVE_ASSET_TO_SECTION, moveAssetToSectionSaga);
  yield takeEvery(FETCH_DEAL_ROOM_CHAT_USERS_REQUEST, fetchChatUsersForDealRoomSaga);
  yield takeEvery(FETCH_DEAL_ROOM_ACTIVE_CHAT_USER_REQUEST, fetchActiveChatUserForDealRoomSaga);
  yield takeEvery(FETCH_DEAL_ROOM_SHARED_ASSETS, fetchDealRoomSharedAssetsSaga);
  yield takeEvery(FETCH_DEAL_ROOM_SHARED_COLLECTIONS, fetchDealRoomSharedCollectionsSaga);
  yield takeEvery(FETCH_DEAL_ROOM_DETAILS, fetchDealRoomDetailsSaga);
  yield takeEvery(FETCH_DEAL_ROOM_SIGNALS, fetchDealRoomSignalsSaga);
  yield takeEvery(FETCH_DEAL_ROOM_HISTORY, fetchDealRoomHistorySaga);
  yield takeEvery(CREATE_DEAL_ROOM_SECTION_REQUEST, createDealRoomSectionSaga);
  yield takeEvery(FETCH_DEAL_ROOM_SMARTCARDS, fetchDealRoomSmartCardsSaga);
  yield takeEvery(FETCH_DEAL_ROOM_ASSET_ANALYTICS_REQUEST, fetchDealRoomAssetAnalyticsSaga);
  yield takeEvery(FETCH_DEAL_ROOM_EVENTS, fetchDealRoomEventsSaga);

}